module.exports = __webpack_public_path__ + "static/media/meritus-2.39cfcfa7.jpg";